<template>
  <v-container v-if="order">
    <GoBackAtTop
      :to="{ name: 'CompanyDistanceOrders', params: { id: $route.params.id } }"
      :label="$t('labels.distance-orders')"
    />
    <div class="title-icon">
      <h1>{{ $t("orders.info.mainTitle") }}</h1>
      <v-btn
        icon
        href="https://www.byggbranschensyrkesnamnd.se/guide/foretag-steg5-godkanna-bestallning/"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    <div v-if="canBeApproved">
      <MessageBox v-if="showWarning" class="mb-7" type="alert" :closable="false">
        <h6>{{ $t("order.info.mb-warning-title") }}</h6>
        <p v-html="$t('order.info.mb-warning-text', {days: (order.profession.daysUntilOrderApproval)})"></p>
        <p>{{$tc("order.info.days-left")}} <b> {{$tc("order.info.days-left-count", daysLeft)}}</b></p>
      </MessageBox>
      <MessageBox v-else class="mb-7" type="info" :closable="false">
        <h6>{{ $t("order.info.mb-warning-title3") }}</h6>
        <p v-html="$t('order.info.mb-warning-text3', {days: daysLeft})"></p>
      </MessageBox>
    </div>
    <div v-else>
      <MessageBox class="mb-7" type="info" :closable="false">
        <h6>{{ $t('order.info.already-approved') }}</h6>
        <p></p>
      </MessageBox>
    </div>
    <MessageBox v-if="canBeApproved" class="mb-7" type="info" :closable="true">
      <h6>{{ $t("order.info.mb-title") }}</h6>
      <p v-html="$t('order.info.mb-text')"></p>
    </MessageBox>
    <MessageBox v-if="canBeApproved" class="mb-7" type="info" :closable="true">
      <p v-html="$t('order.info.mb-step1')"></p>
    </MessageBox>
    <v-text-field
      class="disabled-no-outlined"
      :label="$t('order.info.number')"
      :value="order.id"
      disabled
    ></v-text-field>
    <v-text-field
      class="disabled-no-outlined mt-n2"
      :label="$t('order.info.order-referes')"
      value="Distansutbildning lärling"
      disabled
    ></v-text-field>

    <v-text-field
      class="disabled-no-outlined mt-n2"
      :label="$t('order.info.person')"
      :value="order.student | fullName"
      disabled
    ></v-text-field>

    <v-text-field
      v-if="order.stateId"
      class="mt-n2 prepend-icons disabled-no-outlined"
      :label="$t('labels.status')"
      v-model="statusName"
      :prepend-icon="appOrderIcon"
      disabled
    ></v-text-field>

    <v-text-field
      class="disabled-no-outlined mt-n2"
      :label="$t('order.info.your-reference')"
      :value="order.contactPerson | fullName"
      disabled
    ></v-text-field>
    <v-form ref="form" v-model="valid" :lazy-validation="true">
      <!--Billing address starts here  -->
      <template>
        <div
          v-if="
            order &&
            order.distanceEducationProvider &&
            order.distanceEducationProvider.features &&
            order.distanceEducationProvider.features.hasInvoiceAddress
          "
        >
          <h4>{{ $t("label.invoiceAddress") }}</h4>

          <MessageBox v-if="canBeApproved" class="mb-7" type="info" :closable="true">
            <p v-html="$t('order.info.mb-step2')"></p>
          </MessageBox>

          <p>
            {{ $t("order.company.invoiceAdress-info") }}
            {{ transformInvoice.length > 0 ? "" : $t("order.company.missing-adress") }}
          </p>

          <v-card flat>
            <v-list class="height-small">
              <v-list-item-group v-model="wpModel" :multiple="false">
                <v-radio-group
                  v-model="wpModel"
                  :mandatory="false"
                  :rules="wpModel === '' ? [rules.required] : []"
                >
                  <template v-for="(item, index) in transformInvoice">
                    <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
                    <v-list-item :key="index" @click="selecteOrderWorkplace(item)">
                      <v-list-item-avatar>
                        <v-icon class="icon_style">$sl-workplace</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="item.name"></v-list-item-title>
                        <v-list-item-subtitle
                          >{{ item.postalAddress1 }}, {{ item.postalZip | formatZip }}
                          {{ item.postalCity | uppercase }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div class="v-list-item__radio">
                          <input type="radio" v-model="wpModel" :value="index" />
                          <div class="check">
                            <div class="inside"></div>
                          </div>
                        </div>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-radio-group>
              </v-list-item-group>
            </v-list>
          </v-card>
        </div>
      </template>
      <!-- Send Invoice like -->
      <div v-if="invoiceEmail != ''">
        <h5>{{ $t("order.company.invoiceAddressEmail-title") }}</h5>

        <v-radio-group v-model="invioceDeliveryMethod" :rules="[rules.required]">
          <v-radio label="E-post" value="1"></v-radio>
          <v-radio label="E-faktura" value="3"></v-radio>
          <v-radio label="Post" value="2"></v-radio>
        </v-radio-group>
        <div v-if="invioceDeliveryMethod === '1'">
          <v-text-field
            outlined
            v-model="invoiceEmail"
            label="E-postadress för faktura"
          ></v-text-field>
        </div>
      </div>

      <!--Delivery address starts here  -->
      <div
        v-if="
          order &&
          order.distanceEducationProvider &&
          order.distanceEducationProvider.features &&
          order.distanceEducationProvider.features.hasDeliveryAddress
        "
      >
        <h4 class="mt-2">{{ $t("label.deliveryAddress") }}</h4>
        <MessageBox v-if="canBeApproved" class="mb-7" type="info" :closable="true">
          <p v-html="$t('order.info.mb-step3')"></p>
        </MessageBox>
        <p>
          {{ $t("order.company.deliveryAdress-info")
          }}{{ transformDelivery.length > 0 ? "" : $t("order.company.missing-adress") }}
        </p>

        <v-card flat>
          <v-list class="height-small">
            <v-list-item-group v-model="dlModel" :multiple="false">
              <v-radio-group
                v-model="dlModel"
                :mandatory="false"
                :rules="books > 0 && dlModel == null ? [rules.required] : []"
              >
                <template v-for="(item, index) in transformDelivery">
                  <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
                  <!-- <v-list-item :key="index+2" @click="selecteOrderDelivery(item)"> -->
                  <v-list-item :key="index" @click="selecteOrderDelivery(item)">
                    <v-list-item-avatar>
                      <v-icon class="icon_style">$sl-workplace</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title v-html="item.name"></v-list-item-title>
                      <v-list-item-subtitle
                        >{{ item.postalAddress1 }}, {{ item.postalZip | formatZip }}
                        {{ item.postalCity | uppercase }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <div class="v-list-item__radio">
                        <input type="radio" v-model="dlModel" :value="index" />
                        <div class="check">
                          <div class="inside"></div>
                        </div>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-radio-group>
            </v-list-item-group>
          </v-list>

          <div class="d-flex mt-2">
            <v-text-field
              outlined
              v-model="attention.name"
              :label="$t('order.company.attention.name')"
              class="mr-4"
              :rules="bookDeliveryAddress === '1' && ['1','2','3'].includes(books) ? [rules.required] : []"
            ></v-text-field>

            <v-text-field
              outlined
              v-model="attention.phone"
              :label="$t('order.company.attention.phone')"
              :rules="bookDeliveryAddress === '1' && ['1','2','3'].includes(books) ? [rules.required, rules.phone] : []"
            ></v-text-field>
          </div>
        </v-card>
      </div>

      <!-- Cost Center -->

      <h4 class="mt-4">{{ $t("label.cost-centre") }}</h4>
      <MessageBox v-if="canBeApproved" class="mb-7 mt-4" type="info" :closable="true">
        <p v-html="$t('order.info.mb-step4')"></p>
      </MessageBox>
      <p>{{ $t("order.company.order-costCentre-info") }}</p>
      <v-text-field v-model="costCentre" outlined :disabled="!canBeApproved"></v-text-field>

      <div v-if="order && order.distanceOrderRows && order.distanceOrderRows.length > 0">
        <h4 class="mb-1" v-if="order">{{ $t("labels.order") }}</h4>
        <MessageBox v-if="canBeApproved" class="mb-7 mt-4" type="info" :closable="true">
          <p v-html="$t('order.info.mb-step5')"></p>
        </MessageBox>
        <v-list class="list-order" flat>
          <v-list-item class="mb-n2">
            <v-list-item-content>
              <div class="d-flex">
                <div class="text-uppercase overline">{{ $t("labels.product") }}</div>
                <v-spacer></v-spacer>
                <div class="justify-end">
                  <div class="text-uppercase overline">{{ $t("labels.price") }}</div>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="course in order.distanceOrderRows" :key="course.id">
            <v-list-item-content>
              <v-list-item-title class="product-row">
                <div>
                  <div class="d-flex align-center">{{ course.courseCode | courseCode }}{{ printCourseName(course) }}</div>
                  <div class="caption my-2" v-if="course.assignments && course.assignments.length">{{course.assignments.map(c => c.name).join(', ')}}</div>
                </div>
                <div class="amount" v-if="printCoursePrice(course) != null">{{ printCoursePrice(course) | currency | withCurrencyCode }}</div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="mt-4"></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="pt-4 d-flex justify-space-between">
                <div>{{ $t("orders.info.amount") }}</div>

                {{ fullPrice(order.distanceOrderRows) | currency | withCurrencyCode }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <p class="caption mt-2">
          <i>{{ $t("orders.info.moms-info") }}</i>
        </p>
      </div>

      <!-- STIB Stuff -->
      <div v-if="hasCourseOpportunity">
        <h4 class="mb-4 pt-4" v-html="$t('order.info.training-provider')"></h4>

        <MessageBox v-if="canBeApproved" class="mb-7 mt-4" type="info" :closable="true">
          <p v-html="$t('order.info.mb-step6')"></p>
        </MessageBox>

        <MessageBox class="mb-7 mt-4" type="info">
          <p v-html="$t('order.info.course-opportunities-info')"></p>
        </MessageBox>

        <p class="overline">{{ $t("order.info.course-opportunities") }}</p>
        <v-select
          V-if="hasCourseOpportunityFor('Y2+Y3')"
          v-model="courseOpportunity"
          :items="stibCourseOpportunityY2Y3"
          :disabled="!canBeApproved"
          :label="$t('order.info.course-opportunity') + ' Y2+Y3'"
          :rules="hasCourseOpportunityFor('Y2+Y3') ? [rules.required] : []"
          outlined
          append-icon="$sl-arrow-down"
        ></v-select>

        <MessageBox class="mb-7 mt-4" type="info">
          <p v-html="$t('order.info.course-opportunities-info2')"></p>
        </MessageBox>

        <v-select
          v-model="courseOpportunity2"
          :items="stibCourseOpportunityY4Y5"
          :label="$t('order.info.course-opportunity') + ' Y4+Y5'"
          :rules="hasCourseOpportunityFor('Y4+Y5') ? [rules.required] : []"
          outlined
          append-icon="$sl-arrow-down"
        ></v-select>
        <div v-if="! (get(courseOpportunities, '[\'Y2+Y3\'].length', 0) && get(courseOpportunities, '[\'Y4+Y5\'].length', 0))">
          <MessageBox class="mb-7" type="warning">
            <h6>{{ $t("order.info.course-opportunities-missing") }}</h6>
            <p>{{ $t("order.info.course-opportunities-missing-text") }}</p>
          </MessageBox>
        </div>
      </div>

      <!-- Course picker if no order rows starts here -->

      <div v-if="hasBooks">
        <h4 class="mb-4 pt-4" v-html="$t('order.info.training-provider')"></h4>

        <MessageBox v-if="canBeApproved" class="mb-7 mt-4" type="info" :closable="true">
          <p v-html="$t('order.info.mb-step6')"></p>
        </MessageBox>

        <p class="overline">{{ $t("order.info.book-package") }}</p>
        <v-radio-group
          class="mt-n2"
          v-model="books"
          :rules="[rules.required]"
          :mandatory="false"
        >
          <v-radio label="Nej tack" value="0"></v-radio>
          <v-radio
            v-if="basicBook.display && find(order.distanceOrderRows, ['type', 1])"
            :label="getEbookOptionLabel(basicBook)"
            value="1"
          ></v-radio>
          <v-radio
            v-if="professionBook.display && find(order.distanceOrderRows, ['type', 2])"
            :label="getEbookOptionLabel(professionBook)"
            value="2"
          ></v-radio>
          <v-radio
            v-if="bothBooks.display && find(order.distanceOrderRows, ['type', 3])"
            :label="getEbookOptionLabel(bothBooks)"
            value="3"
          ></v-radio>
        </v-radio-group>

        <p class="overline">{{ $t("order.info.book-package-ship-to") }}</p>

        <v-radio-group
          v-model="bookDeliveryAddress"
          :rules="books != 0 ? [rules.required] : []"
          :mandatory="false"
        >
          <v-radio :label="$t('order.info.opt-company')" value="1"></v-radio>
          <v-radio :label="$t('order.info.opt-apprentice')" value="2"></v-radio>
        </v-radio-group>
      </div>
      <!-- Order Options ends here-->

      <!-- Approve terms and conditions starts here -->
      <div v-if="canBeApproved">
        <h4 class="pt-4">{{ $t("order.info.accept-title") }}</h4>

        <MessageBox class="mb-7 mt-4" type="info" :closable="true">
          <p v-html="$t('order.info.mb-step7', { url: termsOfPurchaseURL(order.distanceEducationProvider.name) })"></p>
        </MessageBox>

        <!-- <p class="overline mb-1">{{ $t("order.info.paytype") }}</p>
        <p>{{ $t("order.info.paytype-text") }}</p> -->

        <p class="overline mb-1">{{ $t("order.info.pay-condition") }}</p>
        <p>{{ $t("order.info.pay-condition") }}</p>

        <p class="caption">{{ $t("order.info.accept-terms") }}</p>
        <div class="d-flex mt-2 mb-6">
          <v-checkbox class="mt-0" v-model="approvedByCompany"></v-checkbox>
          <div class="d-block">
            <p>{{ $t("order.info.accept-terms-checkbox") }}</p>
            <!-- <p>
              <a href="#" class="d-inline">{{ $t("order.info.accept-terms-link") }}</a>
            </p> -->
          </div>
        </div>
      </div>
    </v-form>
    <!-- Approve terms and conditions Ends here -->
    <ActionButton
      @click="saveOrder"
      actionIcon="$sl-like"
      :isDisabled="((approvedByCompany !== true) && !canBeApproved) || isImitatingUser()"
      >{{ $t("labels.approve") }}</ActionButton
    >

    <ActionButton
      flat
      type="application"
      class="mt-6"
      @click="sendEmailClick"
      actionIcon="$sl-send"
      :isDisabled="isImitatingUser()"
      >{{ $t("labels.btnActionEmail") }}</ActionButton
    >
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import { Icons, RulesMixin } from "@/components/mixins";
import GoBackAtTop from "@/components/Common/GoBackAtTop";
import ActionButton from "@/components/Common/ActionButton";
import MessageBox from "@/components/Common/MessageBox";
import filter from "lodash/filter";
import map from "lodash/map";
import find from "lodash/find";
import sortBy from "lodash/sortBy";
import isObject from "lodash/isObject";
import get from "lodash/get";
const SugarDate = require('sugar/date')
import DatePicker from "@/components/Common/DatePicker";
// @group Company
// CompanyDistanceOrder component
export default {
  name: "CompanyDistanceOrder",
  mixins: [Icons, RulesMixin],

  components: {
    GoBackAtTop,
    ActionButton,
    MessageBox,
    DatePicker
  },
  data() {
    return {
      order: {},
      showWarning: false,
      daysLeft: 0,
      options: {},
      deliverys: [],
      workplaces: [],
      invoiceAddress: null,
      invoiceWorkplaceId: null,
      deliveryWorkplaceId: null,
      bookDeliveryAddress: null,
      approvedByCompany: null,
      invioceDeliveryMethod: null,
      books: null,
      costCentre: "",
      invoiceEmail: "",
      deliveryAddress: "",
      wpModel: "",
      dlModel: "",
      appOrderIcon: "",
      valid: false,
      activeRule: false,
      courseOpportunities: {},
      courseOpportunity: null,
      canBeApproved: false,
      courseOpportunity2: null,
      attention: {
        name: '',
        phone: ''
      },
      courseDateApprovalModalVisible: false,
      courseSetAsCompleted: false,
      courseCompletedAt: null
    };
  },
  watch: {
    /**
     * @vuese
     * Used to workplace model (wpModel) and set new values if there is any change
     * @arg called with no argument
     */
    wpModel: function (val) {
      if (val == null) {
        this.activeRule = true;
        this.invoiceWorkplaceId = null;
        this.invoiceEmail = "";
        this.invoiceAddress = null;
      } else {
        const invoiceAddressEmail = get(
          this,
          `transformInvoice[${val}].invoiceAddressEmail`,
          null
        );
        this.invoiceEmail = invoiceAddressEmail;
        if (invoiceAddressEmail) {
          this.invoiceAddress = invoiceAddressEmail;
        }
        this.activeRule = true;
      }
    },
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("basic", ["basicStates", "getOrderStateNameById", "getProfessionById"]),
    ...mapGetters('currentuser', ['isImitatingUser']),

    stibCourseOpportunityY2Y3() {
      return get(this, 'courseOpportunities[\'Y2+Y3\']', [])
    },

    termsOfPurchaseURL() {
      return providerName => (
        providerName === 'STIB' ? 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2025/01/kopevillkor-STIB_2025.pdf' : 
        providerName === 'Liber' ? 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2022/03/Kopvillkor-2022-04-01.pdf' : 
        providerName === 'ME-Skolan' ? 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2022/03/Kopvillkor-ME.pdf' :
        providerName === 'Mobilkranföreningen' ? 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2022/03/Kopvillkor-MKS.pdf' :
        '/'
      )
    },

    stibCourseOpportunityY4Y5() {
      const allY4Y5 = get(this, 'courseOpportunities[\'Y4+Y5\']', [])
      const matcher = new RegExp('^v\\.\\s+([\\d]+)\\s+([\\d]+)')
      try {
        const matches = matcher.exec(this?.courseOpportunity)
        if (matches?.length === 3) {
          const filtered = filter(allY4Y5, (c) => {
            const cm = matcher.exec(c)
            if (cm?.length === 3) {
              return Boolean((parseInt(cm[1]) > parseInt(matches[1]) && parseInt(cm[2]) === parseInt(matches[2])) || cm[2] > matches[2])
            }
            return true
          })
          return filtered
        }
      } catch (error) {
        // nada
      }
      return allY4Y5
    },
    /**
     * @vuese
     * Used to prepate delivery worplaces
     * @arg the argument is an array representing workplaces
     */
    transformDelivery() {
      let arr = [...this.workplaces];
      let newArr = filter(arr, ["isDeliveryWorkplace", true]);
      newArr && newArr.length === 1 ? (this.dlModel = 0) : (this.dlModel = undefined);
      if (newArr && newArr.length === 1) {
        this.dlModel = 0;
        this.deliveryWorkplaceId = newArr[0].id;
      } else {
        this.dlModel = undefined;
        this.deliveryWorkplaceId = null;
      }
      return newArr;
    },
    /**
     * @vuese
     * Used to prepate invoice worplaces
     * @arg the argument is an array representing workplaces
     */
    transformInvoice() {
      let arr = [...this.workplaces];
      let newArr = filter(arr, ["isInvoiceWorkplace", true]);
      if (newArr && newArr.length === 1) {
        this.wpModel = 0;
        this.invoiceWorkplaceId = newArr[0].id;
      } else {
        this.wpModel = undefined;
        this.invoiceWorkplaceId = null;
      }

      return newArr;
    },
    /**
     * @vuese
     * Used to check distance educator setting for this feature
     */
    hasBooks() {
      return (
        this.order &&
        this.order.distanceEducationProvider &&
        this.order.distanceEducationProvider.features &&
        this.order.distanceEducationProvider.features.hasBooks
      );
    },
    /**
     * @vuese
     * Used to check distance educator setting for this feature
     */
    hasCourseOpportunity() {
      const rows = get(this, 'order.distanceOrderRows', [])
      return find(rows, ["remoteId", "Y2+Y3"]) || find(rows, ["remoteId", "Y4+Y5"])
    },
    /**
     * @vuese
     * Used to return basic book data
     */
    basicBook() {
      return this.getBookData("basic");
    },
    /**
     * @vuese
     * Used to return profession book data
     */
    professionBook() {
      return this.getBookData("profession");
    },
    /**
     * @vuese
     * Used to return basic and profession book data
     */
    bothBooks() {
      return this.getBookData("both");
    },
    /**
     * @vuese
     * Used to return status name and order icon
     */
    statusName() {
      if (!this.order && this.order.stateId) {
        return "";
      }

      this.appOrderIcon = this.orderStatusIcon(this.order.stateId);
      return this.getOrderStateNameById(this.order.stateId);
    },
  },
  filters: {
    courseCode(c) {
      if (c && c != "") return c + ": ";
      else {
        return "";
      }
    },
  },
  methods: {
    init() {
      this.fetchListData();
    },

    get: get,

    find: find,

    hasCourseOpportunityFor(remoteId) {
      const rows = get(this, 'order.distanceOrderRows', [])
      return find(rows, ["remoteId", remoteId])
    },

    fetchListData() {
      // @vuese
      // Used to fetch order list for a specific company
      // @arg The argument is a integer value representing company id
      if (this.$route.params) {
        API.getCompanyDistanceOrders(Number(this.$route.params.companyId))
          .then((res) => {
            this.orders = res.data;            
            
            if (this.$route.params.distance_order_id) {
              let o = find(this.orders, [
                "id",
                Number(this.$route.params.distance_order_id),
              ]);
              o ? (this.order = o) : (this.order = {});

              this.getWorkplaces();
              this.canBeApproved = get(this.order, 'state.state', '') === 'sentToCompanyForApproval'

            if(this.CanBeApproved && this.order.latestApprovalDate && this.order.profession && this.order.profession.daysUntilOrderApproval && (this.order.profession.daysUntilOrderApproval)>0  && (SugarDate.Date(this.order.latestApprovalDate).daysFromNow() < Number(this.order.profession.daysUntilOrderApproval)/2))
            {
              this.showWarning=true
              let daysFromNow=Number(SugarDate.Date(this.order.latestApprovalDate).addDays(1).daysFromNow())
              
              if(daysFromNow<0)
                  daysFromNow=0
              this.daysLeft=daysFromNow
            }
            else 
              this.showWarning=false

              if (this.hasCourseOpportunity) {
                API.getCourseOpportunity(o.id).then((res) => {
                  this.courseOpportunities = res.data;
                });
              }
            }
          })
          .then(() => {
            const criteria = (o) => get(o, 'distanceOrderId', null) === this.$route.params.distance_order_id
            const distanceOrderRow = get(this, 'order.distanceOrderRows', []).find(criteria)
            return this.courseSetAsCompleted = !!get(distanceOrderRow, 'completedAt', null) || false
          })
          .catch((error) => {
            console.log("There was an error:", error.res);
          });
      }
    },
    /**
     * @vuese
     * Used to send an email copy
     */
    sendEmailClick() {
      if (
        this.order &&
        this.order.distanceOrderRows &&
        this.order.distanceOrderRows.length > 0
      ) {
        var courses = this.$t("company.review.mail.courses") + ": ";

        var i;
        for (i = 0; i < this.order.distanceOrderRows.length; i++) {
          courses =
            courses + escape("\r\n") + "- " + this.order.distanceOrderRows[i].name;
        }
        if (
          this.basicBook.display == true ||
          this.professionBook.display == true ||
          this.bothBooks.display == true
        ) {
          courses = courses + escape("\r\n\r\n") + this.$t("company.review.mail.options");
          if (this.basicBook.display == true) {
            courses =
              courses +
              escape("\r\n") +
              "- " +
              this.$t("company.review.mail.opt-text") +
              this.basicBook.name;
          }
          if (this.professionBook.display == true) {
            courses =
              courses +
              escape("\r\n") +
              "- " +
              this.$t("company.review.mail.opt-text") +
              this.professionBook.name;
          }
          if (this.bothBooks.display == true) {
            courses =
              courses +
              escape("\r\n") +
              "- " +
              this.$t("company.review.mail.opt-text") +
              this.bothBooks.name;
          }
          courses = courses + escape("\r\n");
        }

        var mailto = "mailto:" + this.$t("company.review.mail.mailto");
        var subject = "?subject=" + this.$t("company.review.mail.subject");
        var body =
          "&body=" +
          this.$t("company.review.mail.body") +
          escape("\r\n\r\n") +
          "---" +
          escape("\r\n\r\n") +
          this.$t("company.review.mail.apprentice") +
          ": " +
          this.getDisplayName() +
          escape("\r\n\r\n") +
          this.$t("company.review.mail.provider") +
          ": " +
          this.order.distanceEducationProvider.name +
          escape("\r\n\r\n") +
          courses +
          escape("\r\n\r\n");

        var a = document.createElement("a");
        a.href = mailto + subject + body;
        a.click();
      } else {
        this.$events.fire("showError", this.$t("company.review.mail.error"));
      }
    },
    // @vuese
    // Used to get the selected workplace address from template
    // @arg The argument is workplace address item or null
    selecteOrderWorkplace(item) {
      if (item && item.id) {
        this.invoiceWorkplaceId = item.id;
        this.invoiceEmail = item.invoiceAddressEmail;
      } else {
        this.invoiceWorkplaceId = null;
        this.invoiceAddressEmail = "";
        this.invoiceAddress = null;
      }
    },
    // @vuese
    // Used to get the selected delivery address from template
    // @arg The argument is delivery address item or null
    selecteOrderDelivery(item) {
      if (item && item.id) {
        this.deliveryWorkplaceId = item.id;
      } else {
        this.deliveryAddress = "";
        this.deliveryWorkplaceId = null;
      }
    },
    /**
     * @vuese
     * Used to display full name
     */
    getDisplayName() {
      if (!this.order.student) {
        return "";
      }
      return (
        (this.order.student.firstName ? this.order.student.firstName : "") +
        " " +
        (this.order.student.lastName ? this.order.student.lastName : "")
      );
    },
    
    fullPrice(items) {
      let sum = null;
      items.forEach(function (value, index, array) {
        sum += value.price;
      });

      return sum
    },

    // @vuese
    // Used to calculate get all the distance packed and display in radio box
    // @arg The argument is distance packet type
    getBookData(type) {
      let h = { display: false, name: type, price: null };
      if (!this.hasBooks) return h;

      const feature = this.order.distanceEducationProvider.features.hasBooks;
      if (!isObject(feature) && feature[type]) return h;
      
      if (feature[type] && feature[type].hasOwnProperty(this.order.professionId)) {
        //- We have a profession specific price
        h.price = feature[type][this.order.professionId];

        //- If "price" isn't null, we want to display it
        if (feature[type][this.order.professionId] !== null) {
          h.display = true;
        }
      } else {
        //- Use default type (if any)
        if (feature[type].default) {
          h.price = feature[type].default;
          h.display = true;
        }
      }
      if (feature[type] && feature[type].name) {
        //- Set name to display
        h.name = feature[type].name;
      }
      return h;
    },

    // @vuese
    // Used to get workplaces list based on company id
    // @arg The arguments are int repressenting company id
    getWorkplaces() {
      if (!this.order && !this.order.companyId) {
        return;
      }
      API.getWorkplaces(this.order.companyId)
        .then((res) => {
          this.workplaces = res.data;
        })
        .catch((err) => {
          this.$events.fire("showError", this.$t("errors.order-validation"));
          console.log(err);
        });
    },
    // @vuese
    // Used to accept and save distance orders
    // @arg The arguments are int repressenting company id , orderid , and data
    saveOrder() {
      if (!this.$refs.form.validate()) {
        this.$events.fire("showError", this.$t("errors.form-validation"));
        return;
      }
      if (this.approvedByCompany == null) {
        this.$events.fire("showError", this.$t("errors.form-validation"));
        return;
      }

      this.options = {
        invioceDeliveryMethod: this.invioceDeliveryMethod,
        invoiceWorkplaceId: this.invoiceWorkplaceId,
        deliveryWorkplaceId: this.deliveryWorkplaceId,
        invoiceEmail: this.invoiceEmail,
        costCentre: this.costCentre,
        invoiceAddress: {},
        deliveryAddress: {},
        bookDeliveryAddress: this.bookDeliveryAddress,
        books: this.books,
        courseOpportunity: this.hasCourseOpportunityFor('Y2+Y3') ? this.courseOpportunity : null,
        courseOpportunity2: this.hasCourseOpportunityFor('Y4+Y5') ? this.courseOpportunity2 : null,
        course: {
          completedAt: this.courseSetAsCompleted ? this.courseCompletedAt : null
        }
      };

      API.saveCompanyDistanceOrders(this.order.companyId, this.order.id, {
        data: { approvedByCompany: this.approvedByCompany, options: { ...this.options, attention: this.attention } },
      })
        .then((res) => {
          this.$events.fire("showInfo", this.$t("orders.order-saved"));
          this.$nextTick(() => {
            this.$router.push({
              name: "CompanyDistanceOrders",
              params: { companyId: this.order.companyId },
            });
          });
          this.approvedByCompany = null;
        })
        .catch((err) => {
          this.$events.fire("showError", this.$t("errors.order-validation"));
          console.log(err);
        });
    },
    getEbookOptionLabel({ name, price }) {
      const { currency, withCurrencyCode } = this.$options.filters;
      const priceWithCurrency = withCurrencyCode(currency(price));
      return `${name} (${priceWithCurrency})`;
    },

    printCourseName(course) {
     if(get(course, 'remoteId', null) === 'KRAVKURSER')
      return `${get(course, 'name', '')} - ${this.$t('special-course.asbest')}`
     return get(course, 'name', '')
    },

    printCoursePrice(course) {
      return get(course, 'remoteId', null) === 'KRAVKURSER' ? null : get(course, 'price', 0)
    },

    handleCourseCompeletedCheck(checked) {
      if ( checked ) {
        this.courseDateApprovalModalVisible = true
      }
    },

    cancelSetCourseCompletedAt() {
      this.courseSetAsCompleted = false
      this.courseDateApprovalModalVisible = false
    },

    setCourseCompletedAt() {
      if ( !this.courseCompletedAt ) {
        this.$events.fire("showError", this.$t("error.save-error"));
        return
      }

      this.courseSetAsCompleted = true
      this.courseDateApprovalModalVisible = false
    }
  },
};
</script>

<style scoped>
.height16 {
  height: 16px !important;
}
</style>
